<script>
  // 开发环境
  // const FRT_URL = "http://127.0.0.1/";
  // const BAK_URL = "http://192.168.0.123:8000/";

  // 错误处理
  // const FRT_URL = "http://127.0.0.1/";
  // const BAK_URL = "https://1ding.cn/drf/";

  // 测试环境
  // const FRT_URL = "http://dev.1ding.cn/";
  // const BAK_URL = "http://dev.1ding.cn/drf/";

  // 运行环境
  const FRT_URL = "https://1ding.cn/";
  const BAK_URL = "https://1ding.cn/drf/";

  export default {
    FRT_URL,
    BAK_URL
  };
</script>